import {HorizontalBarRepresentation} from "../../components/shared/charts/BarRepresentation";
import COLOR from "../../theme/colors";

const DailyComplaintRegistrations = ({complaintRegistrations}) => {
    const {
        datapoints = [],
        title = "Daily Complaints",
        // xLabel = "",
        // yLabel = ""
    } = complaintRegistrations || {};
    return (
        <HorizontalBarRepresentation
            data={datapoints}
            title={title}
            color={COLOR.BAR_CHART}
            xAxisDataKey={"value"}
            yAxisDataKey={"count"}
        />
    );
};

export default DailyComplaintRegistrations;
